const DislikeIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="22" fill="#EEF2FF" />

      <path
        d="M20 26V16H16C15.4 16 15 16.4 15 17V25C15 25.6 15.4 26 16 26H20ZM22 26L26 34C26.5 35 28 34.5 28 33.2V26H31C32.1 26 33 25.1 33 24C33 23.8 33 23.6 32.9 23.4L30.8 16.4C30.5 15.5 29.7 15 28.8 15H22V26Z"
        fill="#1E1B6A"
      />
    </svg>
  );
};

export default DislikeIcon;
